// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__K4fVl","list":"Tabs_list__N3lvy","hidden":"Tabs_hidden__YRAC9"};